import CryptoJS from 'crypto-js';

const SECRET_KEY = process.env.VUE_APP_SECRET_KEY || 'your-default-secret-key'; // Store in .env

export function encrypt(data) {
    const stringData = JSON.stringify(data);
    return CryptoJS.AES.encrypt(stringData, SECRET_KEY).toString();
}

export function decrypt(ciphertext) {
    try {
        const bytes = CryptoJS.AES.decrypt(ciphertext, SECRET_KEY);
        const decrypted = bytes.toString(CryptoJS.enc.Utf8);
        return JSON.parse(decrypted);
    } catch (e) {
        console.warn("Decryption failed", e);
        return null;
    }
}
